jQuery( document ).ready(function( $ ) {
	
    $(function() {
    //caches a jQuery object containing the header element
    var header = $(".top-bar");
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 20) {
            header.addClass("scrolling");
        } else {
            header.removeClass("scrolling");
        }
    });
});
 

});